import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@beweegbaas/ui";
import { createFileRoute } from "@tanstack/react-router";
import { UpdateEmailForm } from "#/modules/user.account-settings/components/form.update-email";
import { UpdateNameForm } from "#/modules/user.account-settings/components/form.update-name";
import { getAccountUserInfo } from "#/modules/user.account-settings/user.functions";
import { m } from "#/paraglide/messages";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/admin/account-settings/account-info",
)({
  loader: () => getAccountUserInfo(),
  component: AccountInfoPage,
});

function AccountInfoPage() {
  const userInfo = Route.useLoaderData();

  return (
    <div className="flex flex-col gap-6">
      <Card>
        <CardHeader>
          <CardTitle>{m["common.fields.name"]()}</CardTitle>
          <CardDescription>{m["account.name_description"]()}</CardDescription>
        </CardHeader>
        <CardContent>
          <UpdateNameForm userInfo={userInfo} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>{m["common.fields.email"]()}</CardTitle>
          <CardDescription>{m["account.email_description"]()}</CardDescription>
        </CardHeader>
        <CardContent>
          <UpdateEmailForm userInfo={userInfo} />
        </CardContent>
      </Card>
    </div>
  );
}
